'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/~/function-bind/index.js
// module id = 459
// module chunks = 2